<emm-no-submenus
    *ngIf="!isLoading && selectedConsumer && selectedLocation && isEmpty"
    [selectedConsumerName]="selectedConsumer.name"
></emm-no-submenus>
<tree-root
    *ngIf="selectedLocation && !isEmpty"
    class="node-tree"
    [nodes]="items"
    [options]="options"
    (moveNode)="onMoveNode($event)"
    (dragstart)="handleDragStart()"

>
    <ng-template #treeNodeTemplate let-node let-index="index">
        <div
            [attr.data-testid]="node?.data?.name"
            [contextMenu]="nodeMenu"
            [contextMenuValue]="node.data"
            [matTooltip]="node?.data?.data?.disabled ? node.data.data.disabledSource : ''"
            [ngClass]="{ 'node-disabled': selectedConsumer?.tag !== 'MMS_LICENSEE' &&
            selectedConsumer?.tag !== 'MENU_ALIGNMENT' && node?.data?.data?.disabled,
            'node-disabled-MMS': node?.data?.data?.disabled &&
            (node?.data?.data?.disabledCode === 115 || node?.data?.data?.disabledCode === 116) &&
            (selectedConsumer?.tag === 'MMS_LICENSEE' || selectedConsumer?.tag === 'MENU_ALIGNMENT'),
            node: true }"
        >
            <span [ngClass]="{ 'strikethrough': node?.data?.isStruck }">
                {{ node?.data?.name }}
                <mat-icon *ngIf="isSubmenu(node) && node.id.includes('_R1')"
                          class="new-submenu-icon"
                          matTooltip="This submenus uses some Common Items">
                    fiber_new
                </mat-icon>
                <mat-icon *ngIf="isCommonItem(node)"
                          class="common-item-icon"
                          matTooltip="Common Item">
                    link
                </mat-icon>
            </span>
            <span [ngStyle]="{ fontSize: '13px' }" *ngIf="showTags$ | async">
                - {{ node?.data?.data?.tag }}
            </span>

            <!-- Display info icon when `fromBase` flag is false to indicate location has a snapshot override -->
            <!-- This may be deprecated once attribute table overrides are implemented -->
            <span *ngIf="node?.data?.data?.typeName == 'Submenu'">
                <mat-icon
                    *ngIf="node?.data?.data?.fromBase == false"
                    class="icon copy-icon"
                    matTooltip="Submenu has location overrides"
                >copy_all</mat-icon>
            </span>

            <mat-icon
                *ngIf="node?.data?.data?.selected"
                class="icon green-check"
                matTooltip="Selected option"
            >check
            </mat-icon>
        </div>
        <context-menu #nodeMenu [disabled]="readonly || selectedFeatureScope === 'Client'">
            <!-- Refresh -->
            <ng-template contextMenuItem (execute)="reloadItemsOverload()">
                <span [attr.data-testid]="'refresh_items'">Refresh</span>
                <mat-icon>refresh</mat-icon>
            </ng-template>

            <!-- Old Enable/disable -->
            <ng-template contextMenuItem (execute)="toggleDisabled(node)"
                         *ngIf="!(newDisableToggle$ | async) && selectedFeatureScope === 'Global' && !node?.data?.data?.commonItem">
                <span
                    [attr.data-testid]="'enable_disable'">{{ node?.data?.data?.disabled ? 'Enable' : 'Disable' }}</span>
                <mat-icon>{{ node?.data?.data?.disabled ? 'visibility' : 'visibility_off' }}</mat-icon>
            </ng-template>

            <!-- New Enable/disable -->
            <ng-template contextMenuItem (execute)="toggleDisabled(node)"
                         *ngIf="(newDisableToggle$ | async) && selectedFeatureScope === 'Global' && !node?.data?.data?.commonItem">
                <!--                disabledCode: 111 means Disabled by EMM user-->
                <span [attr.data-testid]="'enable_disable'">
                    {{ !node?.data?.data?.disabled || node?.data?.data?.disabledCode !== 111 ?
                    'Disable' : 'Enable' }}
                </span>
                <mat-icon>{{ !node?.data?.data?.disabled || node?.data?.data?.disabledCode !== 111 ?
                    'visibility_off' : 'visibility' }}</mat-icon>
            </ng-template>

            <!-- Add -->
            <ng-template *ngIf="allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
            && !node?.data?.data?.commonItem"
                         contextMenuItem (execute)="add(node)">
                <span [attr.data-testid]="'add_item'">Add Item</span>
                <mat-icon>add</mat-icon>
            </ng-template>

            <!-- Copy -->
            <ng-template
                *ngIf="allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
                && !node?.data?.data?.commonItem"
                contextMenuItem
                (execute)="copy(node)"
            >
                <span [attr.data-testid]="'copy_item_button'"
                      matTooltip="This will overwrite any item or tagpath you have previously copied">Copy Item</span>
                <mat-icon>file_copy</mat-icon>
            </ng-template>

            <!-- Copy Tagpath -->
            <ng-template
                *ngIf="allowStructureChanges"
                contextMenuItem
                (execute)="copyTagpath(node)"
            >
                <span [attr.data-testid]="'copy_item_tagpath_button'"
                      matTooltip="This will overwrite any item or tagpath you have previously copied"
                >Copy Tagpath</span>
                <mat-icon>file_copy</mat-icon>
            </ng-template>

            <!-- Delete -->
            <ng-template *ngIf="allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN' &&
            !isSubmenu(node) && !node?.data?.data?.commonItem"
                         contextMenuItem (execute)="deleteNode(node)">
                <span [attr.data-testid]="'delete_item'">Delete</span>
                <mat-icon>delete</mat-icon>
            </ng-template>

            <!-- Delete cascade -->
            <ng-template
                *ngIf="allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
                && !node?.data?.data?.commonItem"
                contextMenuItem
                [visible]="!isSubmenu(node)"
                (execute)="deleteCascade(node)"
            >
                <span [attr.data-testid]="'delete_cascade'">Delete Cascade</span>
                &nbsp;
                <mat-icon>delete_sweep</mat-icon>
            </ng-template>

            <!-- Paste -->
            <ng-template
                *ngIf="allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
                && !node?.data?.data?.commonItem"
                contextMenuItem
                [disabled]="!isCopied"
                (execute)="paste(node)"
            >
                <span [attr.data-testid]="'paste_item_button'">Paste Item</span>
                <mat-icon>content_paste</mat-icon>
            </ng-template>

            <!-- Paste cascade -->
            <ng-template
                contextMenuItem
                [disabled]="!isCopied"
                [visible]="!isSubmenu(node) && isAdmin && allowStructureChanges &&
                selectedFeatureScope === 'Global' && location === 'CHAIN' && !node?.data?.data?.commonItem"
                (execute)="pasteCascade(node)"
            >
                <span [attr.data-testid]="'paste_cascade'">Paste Cascade</span>
                <mat-icon>add_to_photos</mat-icon>
            </ng-template>
        </context-menu>
    </ng-template>
</tree-root>
